var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10H20C21.1046 10 22 10.8954 22 12V14.84C21.9985 15.6038 21.8526 16.3604 21.57 17.07L20.5 19.74C20.1981 20.4981 19.466 20.9967 18.65 21H12.41C11.5059 20.9993 10.639 20.6396 10 20C9.35291 19.3786 8.48702 19.0373 7.59 19.05H7V11.05H7.89C8.581 11.0514 9.22377 10.696 9.59 10.11L10.81 8.11C11.2606 7.39127 11.9251 6.83174 12.71 6.51L13.14 6.34C13.6835 6.12139 14.1038 5.67547 14.29 5.12L14.89 3.34C14.9582 3.13808 15.1469 3.00158 15.36 3H15.5C16.3284 3 17 3.67157 17 4.5V4.89C17.0196 5.58381 16.8649 6.27145 16.55 6.89L15 10ZM4.5 20C4.77614 20 5 19.7761 5 19.5V10.5C5 10.2239 4.77614 10 4.5 10H2.5C2.22386 10 2 10.2239 2 10.5V19.5C2 19.7761 2.22386 20 2.5 20H4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.3847447774e5b2dfc897e5fe671ac480.svg";
export { ForwardRef as ReactComponent };